export const GOOD_KEYWORD_POSITION = [1, 2];
export const AVERAGE_KEYWORD_POSITION = [3, 4, 5, 6];
export const BAD_KEYWORD_POSITION = [7, 8, 9];
